import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './App.scss';
import qs from "qs";
import CountryDataMap from "./components/contry-data/country-data-map";
import MigrationGraph from "./components/migration/migration";
import MigrationFlow from "./components/flow/flow";

function getEl(embedSelector) {
    if (typeof embedSelector === "string") {
        const el = document.querySelector(embedSelector);
        if (!el) return;
        return el;
    } else {
        return embedSelector;
    }
}

function getUrlParams() {
    const params = qs.parse(window.location.search.slice(1));

    return {
        type: params.embed
    };
}

window.addEventListener("DOMContentLoaded", () => {
    const params = getUrlParams();
    if (params) {
        // console.log("Embed params");
        // console.table(params);
        // const forecast = getEl("[data-forecast-inflow-outflow-embed]")
        // if (forecast) {
        //     const root = createRoot(forecast);
        //     params.type='forecast';
        //     root.render(<MigrationFlow {...params} />);
        // }
        // const actual = getEl("[data-inflow-outflow-embed]")
        // if (actual) {
        //     const root = createRoot(actual);
        //     params.type='actual';
        //     root.render(<MigrationFlow {...params} />);
        // }

        const flow = getEl("[data-inflow-outflow-embed]")
        if (getEl("[data-inflow-outflow-embed]")) {
            const root = createRoot(flow);
            root.render(<MigrationFlow {...params} />);
        }

        const migration = getEl("[data-migration-embed]")
        if (getEl("[data-migration-embed]")) {
            const root = createRoot(migration);
            root.render(<MigrationGraph {...params} />);
        }

        const country = getEl("[data-country-embed]")
        if (getEl("[data-country-embed]")) {
            const root = createRoot(country);
            root.render(<CountryDataMap {...params} />);
        }
    }
});
